var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlower(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1608 26.9336H26.7446V53.2481H13.6011C13.4549 53.2529 13.3082 53.2553 13.1608 53.2553C5.89228 53.2553 -3.43323e-05 47.363 -3.43323e-05 40.0944C-3.43323e-05 32.8391 5.87096 26.9549 13.1213 26.9337V26.9336H13.1608Z",
    fill: "#FFED29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1608 26.9336H26.7446V53.2481H13.6011C13.4549 53.2529 13.3082 53.2553 13.1608 53.2553C5.89228 53.2553 -3.43323e-05 47.363 -3.43323e-05 40.0944C-3.43323e-05 32.8391 5.87096 26.9549 13.1213 26.9337V26.9336H13.1608Z",
    fill: "#5DCC97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8391 26.9336H53.2554V53.2481H66.3988C66.545 53.2529 66.6918 53.2553 66.8391 53.2553C74.1077 53.2553 80 47.363 80 40.0944C80 32.8391 74.129 26.955 66.8787 26.9337V26.9336H66.8391Z",
    fill: "#FFED29"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8391 26.9336H53.2554V53.2481H66.3988C66.545 53.2529 66.6918 53.2553 66.8391 53.2553C74.1077 53.2553 80 47.363 80 40.0944C80 32.8391 74.129 26.955 66.8787 26.9337V26.9336H66.8391Z",
    fill: "#FFED29"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.2554 13.1212V26.7445L26.9409 26.7445V13.6021C26.9361 13.4556 26.9337 13.3085 26.9337 13.1609C26.9337 5.89234 32.826 2.67029e-05 40.0945 2.67029e-05C47.3498 2.67029e-05 53.2339 5.87092 53.2553 13.1212H53.2554Z",
    fill: "#3A70F6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.2554 13.1212V26.7445L26.9409 26.7445V13.6021C26.9361 13.4556 26.9337 13.3085 26.9337 13.1609C26.9337 5.89234 32.826 2.67029e-05 40.0945 2.67029e-05C47.3498 2.67029e-05 53.2339 5.87092 53.2553 13.1212H53.2554Z",
    fill: "#3A70F6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9338 66.8789V53.2556H53.2483V66.3973C53.2531 66.5441 53.2556 66.6914 53.2556 66.8393C53.2556 74.1078 47.3633 80.0001 40.0947 80.0001C32.8394 80.0001 26.9553 74.1292 26.9339 66.8789H26.9338Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9338 66.8789V53.2556H53.2483V66.3973C53.2531 66.5441 53.2556 66.6914 53.2556 66.8393C53.2556 74.1078 47.3633 80.0001 40.0947 80.0001C32.8394 80.0001 26.9553 74.1292 26.9339 66.8789H26.9338Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower);
export default __webpack_public_path__ + "static/media/flower.442ecb0dfdae76bee71e3a600951cf55.svg";
export { ForwardRef as ReactComponent };